import { render, staticRenderFns } from "./home-pc.vue?vue&type=template&id=7760fac4"
import script from "./home-pc.vue?vue&type=script&lang=js"
export * from "./home-pc.vue?vue&type=script&lang=js"
import style0 from "./home-pc.vue?vue&type=style&index=0&id=7760fac4&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports